var _excluded = ["className", "popupClassName", "mobileProps", "value", "minDate", "maxDate", "format", "showTime", "onChange"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { isMobile } from '@fe-util/common';
import { DatePicker as AntdDatePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import MobileDatePanel from "./components/MobileDatePanel";
import "./index.less";
var RangePicker = AntdDatePicker.RangePicker,
  QuarterPicker = AntdDatePicker.QuarterPicker,
  YearPicker = AntdDatePicker.YearPicker,
  MonthPicker = AntdDatePicker.MonthPicker,
  WeekPicker = AntdDatePicker.WeekPicker;

// const ReRangePicker = () => {
//   // TODO
//   return (
//     <RangePicker
//       popupClassName={`iron-date-picker`}
//       rootClassName="iron-date-picker"
//     />
//   );
// };

var DatePicker = function DatePicker(props) {
  var className = props.className,
    popupClassName = props.popupClassName,
    mobileProps = props.mobileProps,
    value = props.value,
    minDate = props.minDate,
    maxDate = props.maxDate,
    formatProp = props.format,
    showTime = props.showTime,
    onChange = props.onChange,
    restProps = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _React$useState3 = React.useState(value),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    innerValue = _React$useState4[0],
    setInnerValue = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    trigger = _React$useState6[0],
    setTrigger = _React$useState6[1];
  // const { format } = formatProp || { format: 'YYYY-MM-DD HH:mm:ss' };

  // console.log('DatePickerProps', props);

  React.useEffect(function () {
    setInnerValue(value);
    console.log(JSON.stringify(value));
  }, [JSON.stringify(value)]);
  if (isMobile()) {
    return /*#__PURE__*/React.createElement(AntdDatePicker, _extends({
      className: "iron-date-picker ".concat(className !== undefined ? className : ''),
      popupClassName: "iron-date-picker ".concat(popupClassName)
    }, restProps, {
      onChange: onChange,
      format: formatProp,
      showNow: false,
      showTime: showTime,
      onOpenChange: function onOpenChange(open) {
        setTrigger(Date.now());
        setOpen(open);
      },
      value: innerValue,
      maxDate: maxDate,
      minDate: minDate,
      panelRender: function panelRender() {
        return /*#__PURE__*/React.createElement(MobileDatePanel, _extends({}, mobileProps, {
          open: open,
          max: maxDate ? new Date(dayjs(maxDate).toString()) : undefined,
          min: minDate ? new Date(dayjs(minDate).toString()) : undefined,
          onConfirm: function onConfirm(date) {
            var dateObj = dayjs(date);
            setInnerValue(dateObj);
            setOpen(false);
            if (onChange) {
              var format = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
              onChange(dateObj, dayjs(dateObj).format(
              // @ts-ignore
              (formatProp === null || formatProp === void 0 ? void 0 : formatProp.format) || format));
            }
          },
          triggerToken: trigger,
          onClose: function onClose() {
            setOpen(false);
          }
        }));
      }
    }));
  }
  return /*#__PURE__*/React.createElement(AntdDatePicker, _extends({
    className: "iron-date-picker ".concat(className !== undefined ? className : ''),
    popupClassName: "iron-date-picker ".concat(popupClassName)
  }, restProps, {
    onChange: onChange,
    format: formatProp,
    showTime: showTime,
    value: innerValue,
    maxDate: maxDate,
    minDate: minDate
  }));
};
DatePicker.RangePicker = RangePicker;
// DatePicker.TimePicker = <TimePicker />;
DatePicker.QuarterPicker = QuarterPicker;
DatePicker.YearPicker = YearPicker;
DatePicker.MonthPicker = MonthPicker;
DatePicker.WeekPicker = WeekPicker;
export default DatePicker;